import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import { ReactChannelIO } from 'react-channel-plugin';

import Footer from './footer/Footer';
import '../index.css';
import NavbarFixed from './navbar/NavbarTransparent';

const LayoutNew = () => {
  return (
    <ReactChannelIO
      // 04ad9ae3-07f3-4e83-9799-685e80be8622  a421a2f2-3eb5-4190-b43d-c64163a7b0e9
      pluginKey="a421a2f2-3eb5-4190-b43d-c64163a7b0e9"
      customLauncherSelector=".channel-btn"
      language="ko"
      autoBoot
    >
      <Box
        display="static"
        flexDirection="column"
        alignItems="space-between"
        justifyContent="space-between"
        sx={{
          top: 0,
          height: '100%'
        }}
      >
        <Stack sx={{ minHeight: '54px' }}>
          <NavbarFixed />
        </Stack>
        <Stack sx={{ flexGrow: 1 }}>
          <Outlet />
        </Stack>

        <Stack height="184px">
          <Footer />
        </Stack>
      </Box>
    </ReactChannelIO>
  );
};

export default LayoutNew;
